import React from 'react';
import styled from 'styled-components';
import { FiSearch, FiFilter, FiX } from 'react-icons/fi';
import theme from '../../styles/theme';

const FiltrosContainer = styled.div`
  background: ${theme.colors.background.secondary};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.xl};
  padding: ${theme.spacing[6]};
  margin-bottom: ${theme.spacing[6]};
`;

const FiltrosHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing[6]};
`;

const Title = styled.h3`
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.lg};
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
`;

const Actions = styled.div`
  display: flex;
  gap: ${theme.spacing[2]};
`;

const ActionButton = styled.button`
  padding: ${theme.spacing[2]} ${theme.spacing[4]};
  border: 1px solid ${theme.colors.border.primary};
  background: transparent;
  color: ${theme.colors.text.secondary};
  border-radius: ${theme.borderRadius.lg};
  font-size: ${theme.fontSizes.sm};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};

  &:hover {
    background: ${theme.colors.background.primary};
    color: ${theme.colors.primary[500]};
    border-color: ${theme.colors.primary[500]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const FiltrosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${theme.spacing[4]};
`;

const FiltroGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`;

const Label = styled.label`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  font-weight: 500;
`;

const Input = styled.input`
  padding: ${theme.spacing[3]};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.sm};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary[500]};
    box-shadow: 0 0 0 3px ${theme.colors.primary[500]}20;
  }

  &::placeholder {
    color: ${theme.colors.text.muted};
  }
`;

const Select = styled.select`
  padding: ${theme.spacing[3]};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.sm};
  transition: all 0.2s ease;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary[500]};
    box-shadow: 0 0 0 3px ${theme.colors.primary[500]}20;
  }

  option {
    background: ${theme.colors.background.primary};
    color: ${theme.colors.text.primary};
  }
`;

const FunisFiltros = ({ filtros, onFiltrosChange, onBuscar, loading }) => {
  const handleInputChange = (field, value) => {
    onFiltrosChange({
      ...filtros,
      [field]: value
    });
  };

  const limparFiltros = () => {
    const filtrosLimpos = {
      search: '',
      ativo: '',
      page: 1,
      limit: filtros.limit || 10
    };
    onFiltrosChange(filtrosLimpos);
    if (onBuscar) {
      onBuscar(filtrosLimpos);
    }
  };

  const temFiltrosAtivos = filtros.search !== '' || filtros.ativo !== '';

  return (
    <FiltrosContainer>
      <FiltrosHeader>
        <Title>
          <FiFilter />
          Filtros de Busca
        </Title>
        <Actions>
          <ActionButton onClick={limparFiltros} disabled={!temFiltrosAtivos}>
            <FiX />
            Limpar Filtros
          </ActionButton>
          <ActionButton onClick={onBuscar} disabled={loading}>
            <FiSearch />
            {loading ? 'Buscando...' : 'Buscar'}
          </ActionButton>
        </Actions>
      </FiltrosHeader>

      <FiltrosGrid>
        {/* Busca geral */}
        <FiltroGroup>
          <Label>Busca Geral</Label>
          <Input
            type="text"
            placeholder="Nome ou descrição..."
            value={filtros.search || ''}
            onChange={(e) => handleInputChange('search', e.target.value)}
          />
        </FiltroGroup>

        {/* Status */}
        <FiltroGroup>
          <Label>Status</Label>
          <Select
            value={filtros.ativo || ''}
            onChange={(e) => handleInputChange('ativo', e.target.value)}
          >
            <option value="">Todos</option>
            <option value="true">Ativos</option>
            <option value="false">Inativos</option>
          </Select>
        </FiltroGroup>
      </FiltrosGrid>
    </FiltrosContainer>
  );
};

export default FunisFiltros;

